import axios from "axios";
import qs from "qs";

type IGetSalesChannelsReturn = {
    code: string,
    label: string
}[]

export const getSalesChannels = async (params: any): Promise<IGetSalesChannelsReturn> => {
    const response = await axios.get('/booking/search/saleschannels', {
        params: { ...params, tenants: params.tenants?.join(',') || "", dealers: params.dealers?.join(',') || "drivalia" },
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true })
    });
    return response.data;
};

export default getSalesChannels;